import { useEffect } from 'react'

/**
 * Modal base de LGR.
 *
 * REGLA: tocar afuera NO cierra. Se cierra con la ✕ o con Escape.
 *
 * Antes el fondo cerraba y se perdía todo lo cargado — pasaba sobre todo en el
 * alta de cliente, donde un click al costado borraba media ficha tipeada. Un
 * modal de esta app casi siempre tiene un formulario adentro: cerrarlo por
 * accidente cuesta trabajo real, y volver a abrirlo no cuesta nada.
 */
// Pila de modales abiertos: Escape cierra SOLO el de arriba. Sin esto, con un
// modal anidado (alta de cliente desde una venta) un Escape cerraba los dos y
// se perdía lo tipeado en el de atrás.
const abiertos = []

export default function Modal({ title, onClose, children, maxWidth = '500px' }) {
  useEffect(() => {
    const yo = {}
    abiertos.push(yo)
    const alTeclear = (e) => { if (e.key === 'Escape' && abiertos[abiertos.length - 1] === yo) onClose() }
    document.addEventListener('keydown', alTeclear)

    return () => {
      document.removeEventListener('keydown', alTeclear)
      const i = abiertos.indexOf(yo)
      if (i !== -1) abiertos.splice(i, 1)
    }
  }, [onClose])

  return (
    <div style={styles.overlay}>
      <div style={{ ...styles.modal, maxWidth }}>
        <div style={styles.header}>
          <h3 style={styles.title}>{title}</h3>
          <button style={styles.close} onClick={onClose} aria-label="Cerrar">×</button>
        </div>
        <div style={styles.body}>{children}</div>
      </div>
    </div>
  )
}

const styles = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: 'white', borderRadius: '10px', width: '100%', maxWidth: '500px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1.25rem', borderBottom: '1px solid #e2e8f0' },
  title: { margin: 0, fontSize: '1rem', fontWeight: '700', color: '#1e293b' },
  close: { background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#64748b', lineHeight: 1 },
  body: { padding: '1.25rem', maxHeight: '80vh', overflowY: 'auto' },
}
